import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { style } from "./style";
import Countdown from "react-countdown-now";
/*----styles----*/
class CountDownComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      expiredTime: 0,
    };
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setState({
      expiredTime: this.props.expiredTime,
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (this.countdown.isCompleted() || this.countdown.isPaused()) &&
      nextProps.expiredTime !== this.state.expiredTime
      ? true
      : false;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.expiredTime !== this.state.expiredTime) {
      this.setState({
        expiredTime: nextProps.expiredTime,
      });
    }
  }
  // Pauses the running countdown
  pause = () => {
    return this.countdown.pause();
  };
  // Returns a boolean for whether the countdown has been paused or not
  isPaused = () => {
    return this.countdown.isPaused();
  };
  start = () => {
    if (this.countdown) this.countdown.start();
  };
  render() {
    const { classes, t, resend, sendDiffentPhone } = this.props;
    let { expiredTime } = this.state;
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        return (
          <div className={classes.wrapText}>
            <Typography
              onClick={resend}
              color="secondary"
              style={{ float: "left", cursor: "pointer" }}
            >
              {t("resend")}
            </Typography>
            {sendDiffentPhone && (
              <Typography
                onClick={sendDiffentPhone}
                color="secondary"
                style={{ float: "right", cursor: "pointer" }}
              >
                {t("forgot_send_different_number")}
              </Typography>
            )}
          </div>
        );
      } else {
        return (
          <span className={classes.numberExpire}>
            {`${t(
              "register_aciveCode_will_expired_after"
            )} ${minutes}:${seconds} ${t("register_minutes")}`}
          </span>
        );
      }
    };
    return (
      <Countdown
        ref={(id) => (this.countdown = id)}
        date={Date.now() + expiredTime}
        renderer={renderer}
        autoStart={true}
      />
    );
  }
}
const mapState = (state) => ({});
const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: true })(CountDownComponent)
  )
);
